import { render, staticRenderFns } from "./paraconfig014-f-dimming.vue?vue&type=template&id=4c477d9f&"
import script from "./paraconfig014-f-dimming.vue?vue&type=script&lang=js&"
export * from "./paraconfig014-f-dimming.vue?vue&type=script&lang=js&"
import style0 from "./paraconfig014-f-dimming.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports